import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoaderService } from '../Services/loader.service';
import { finalize } from 'rxjs';

const SKIP_LOADING_HEADER = 'skip-loading';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoaderService);
  const skipLoading = req.headers.get(SKIP_LOADING_HEADER) === 'true';

  if (!skipLoading) {
    loader.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (!skipLoading) {
        loader.hide();
      }
    })
  );
};
